import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isEmailLoading: false,
  isVerifyCodeSuccessful: false,
  isVerifyCodeSent: false,
  phoneErrors: null,
  formErrors: null,
  emailErrors: null,
  notificationErrors: null,
  mailingAddress: '',
  mfaEnabled: false,
  editingPhone: false,
  editingEmail: false,
  editingRegistrationEmail: false,
  editingEmailAndPhone: false,
  editingNotifications: false,
  editingTimezone: false,
  emailAddress: '',
  timeZoneErrors: null,
  editRegistrationEmailErrors: null,
};

export const profileSlice = createSlice({
  name: 'profileSlice',
  initialState,
  reducers: {
    resetState: () => {
      return { ...initialState };
    },
    setLoading: (state, action) => {
      return { ...state, isLoading: action.payload };
    },
    setEmailLoading: (state, action) => {
      return { ...state, isEmailLoading: action.payload };
    },
    setVerifyCodeSuccessful: (state, action) => {
      return { ...state, isVerifyCodeSuccessful: action.payload };
    },
    setVerifyCodeSent: (state, action) => {
      return { ...state, isVerifyCodeSent: action.payload };
    },
    setPhoneErrors: (state, action) => {
      return { ...state, phoneErrors: action.payload };
    },
    setEmailErrors: (state, action) => {
      return { ...state, emailErrors: action.payload };
    },
    setNotificationErrors: (state, action) => {
      return { ...state, notificationErrors: action.payload };
    },
    setEditingNotifications: (state, action) => {
      return { ...state, editingNotifications: action.payload };
    },
    setEditingPhone: (state, action) => {
      return { ...state, editingPhone: action.payload };
    },
    setEditingEmail: (state, action) => {
      return { ...state, editingEmail: action.payload };
    },
    setEditingRegistrationEmail: (state, action) => {
      return { ...state, editingRegistrationEmail: action.payload };
    },
    setEditingEmailAndPhone: (state, action) => {
      return { ...state, editingEmailAndPhone: action.payload };
    },
    setFormErrors: (state, action) => {
      return { ...state, formErrors: action.payload };
    },
    setMFAEnabled: (state, action) => {
      return { ...state, mfaEnabled: action.payload };
    },
    setEditingTimezone: (state, action) => {
      return { ...state, editingTimezone: action.payload };
    },
    setEmailAddress: (state, action) => {
      return { ...state, emailAddress: action.payload };
    },
    setEditRegistrationEmailErrors: (state, action) => {
      return { ...state, editRegistrationEmailErrors: action.payload };
    },
    setGoPaperlessErrors: (state, action) => {
      return { ...state, goPaperlessErrors: action.payload };
    },
    setTimezoneErrors: (state, action) => {
      return { ...state, timezoneErrors: action.payload };
    },
    setDeleteUserErrors: (state, action) => {
      return { ...state, deleteUserErrors: action.payload };
    },
  },
});

export const {
  resetState,
  setLoading,
  setEmailLoading,
  setVerifyCodeSuccessful,
  setVerifyCodeSent,
  setPhoneErrors,
  setEmailErrors,
  setEmailAddress,
  setNotificationErrors,
  setEditingNotifications,
  setEditingEmail,
  setEditingRegistrationEmail,
  setEditingPhone,
  setEditingEmailAndPhone,
  setEditingTimezone,
  setFormErrors,
  setGoPaperlessErrors,
  setDeleteUserErrors,
  setEditRegistrationEmailErrors,
  setTimezoneErrors,
} = profileSlice.actions;
export default profileSlice.reducer;
